export const AdminReservationApplicationController = {
    index(): void {},
    show(): void {},
    approve(): void {},
    reject(): void {},
    bulkDestroy(): void {},
    destroy(): void {},
};
